// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import PurchaseOrder from 'services/data/purchase-order';
import ExpenseBill from 'services/data/expense-bill';

// Components
import ExpenseBillForm from './forms/expense-bill-form';


// Component
export default class AddExpenseBill extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    // Save the initial form values in the state on mount, because we don't want
    // to reinitialize the form if something about the PO changes while we're editing
    // it (like when it gets set to syncing while saving to the api)
    this.setState({ initialFormValues: getInitialFormValues(this.props.purchaseOrder) });
  }

  render() {
    const { cancel, purchaseOrder } = this.props;

    return (
      <ExpenseBillForm
        cancel={this.props.cancel}
        form={`addExpenseBillForm-${purchaseOrder.id}`}
        initialValues={this.state.initialFormValues}
        header="Add Charge"
        onSubmit={(values) =>
          ExpenseBill.create(formatExpenseBill(values))
            .then(() => PurchaseOrder.findOne(values.purchaseOrderId, PurchaseOrder.defaultQuery))
            .then(purchaseOrder.update)
            .then(cancel)
            .catch(alerts.catchError)
        }
      />
    );
  }
}

// Prop types
AddExpenseBill.propTypes = {
  cancel: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.object.isRequired
};


// Helper functions
function formatExpenseBill(data) {
  const lineItems = _.filter(data.lineItems, (lineItem) => Number(lineItem.quantity) > 0);
  const lineItemTotal = _.sum(_.map(lineItems, (lineItem) => lineItem.quantity * lineItem.unitCost));

  return {
    purchaseOrder: data.purchaseOrderId,
    date: data.date || moment().toDate(),
    shipping: data.shipping || 0,
    tax: data.tax || 0,
    amount: lineItemTotal + Number(data.shipping || 0) + Number(data.tax || 0),
    lineItems,
    receipt: data.receipt,
    approved: true
  };
}

function getInitialFormValues(purchaseOrder) {
  return {
    purchaseOrderId: purchaseOrder.id,
    date: null,
    lineItems: _.map(purchaseOrder.unbilledLineItems, (lineItem) => ({
      purchaseOrderLineItem: lineItem.id,
      quantity: lineItem.unbilledQuantity,
      unitCost: lineItem.unitCost,
      description: lineItem.description,
      billableQuantity: lineItem.unbilledQuantity
    }))
  };
}
